// PostHog Configuration
import posthog from 'posthog-js';

// Environment variables (you'll need to add these to your .env file)
const POSTHOG_KEY = process.env.REACT_APP_POSTHOG_KEY || 'YOUR_POSTHOG_KEY_HERE';
const POSTHOG_HOST = process.env.REACT_APP_POSTHOG_HOST || 'https://app.posthog.com';

// Report URLs carry capability tokens (1-hour app tokens, 90-day share
// tokens). They must never land in analytics — a PostHog event with
// $current_url would quietly archive live secret links. Redact the token
// path segment from every string property on every event.
const REPORT_TOKEN_RE = /\/r\/[A-Za-z0-9_-]{8,}/g;
const redactReportTokens = (value) =>
  typeof value === 'string' ? value.replace(REPORT_TOKEN_RE, '/r/__token__') : value;

// Initialize PostHog
export const initPostHog = () => {
  if (typeof window !== 'undefined') {
    // Check if we have valid credentials
    const hasValidKey = POSTHOG_KEY && POSTHOG_KEY !== 'YOUR_POSTHOG_KEY_HERE';
    
    if (!hasValidKey) {
      console.warn('PostHog: Missing or invalid API key. Check your environment variables.');
      console.warn('Expected: REACT_APP_POSTHOG_KEY, Got:', POSTHOG_KEY ? 'placeholder value' : 'undefined');
      return;
    }

    posthog.init(POSTHOG_KEY, {
      api_host: POSTHOG_HOST,
      // Enable in production, disable in development for testing
      loaded: (posthog) => {
        const env = process.env.NODE_ENV || 'unknown';
        console.log(`PostHog initialized successfully in ${env} mode`);
        if (process.env.NODE_ENV === 'development') {
          console.log('PostHog Key (first 10 chars):', POSTHOG_KEY.substring(0, 10) + '...');
          // Uncomment the line below to disable PostHog in development
          // posthog.opt_out_capturing();
        }
      },
      // Additional configuration
      capture_pageview: false, // We'll handle pageviews manually for better control
      capture_pageleave: true,
      person_profiles: 'identified_only', // Only create profiles for identified users
      // Strip report capability tokens from $current_url/$pathname/$referrer
      // etc. on every event (manual pageviews AND automatic $pageleave).
      sanitize_properties: (properties) => {
        for (const key in properties) {
          properties[key] = redactReportTokens(properties[key]);
        }
        return properties;
      },
    });
  }
};

export { posthog }; 